import { Box, IconButton, Paper, SxProps, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface Props {
    numPages: number;
    currentPage: number;
    setPage: (page: number) => void;
    sx?: SxProps;
    mapNames?: string[];
}

export default function FloatingPagination(props: Props) {
    const currentZoneName = props.mapNames?.[props.currentPage];
    const hasPrev = props.currentPage > 0;
    const hasNext = props.currentPage < props.numPages - 1;

    return (
        <Box
            sx={{
                position: 'absolute',
                bottom: '0px',
                width: '100%',
                paddingBottom: '20px',
                paddingTop: '20px',
                display: 'flex',
                zIndex: 500,
                pointerEvents: 'none',
                ...props.sx,
            }}
        >
            <Paper
                elevation={2}
                sx={{
                    borderRadius: 5,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 1,
                    py: 0.5,
                }}
            >
                <IconButton
                    sx={{ pointerEvents: 'auto' }}
                    disabled={!hasPrev}
                    onClick={() => props.setPage(props.currentPage - 1)}
                    size="small"
                >
                    <ChevronLeftIcon />
                </IconButton>
                <Typography
                    sx={{
                        pointerEvents: 'auto',
                        minWidth: '60px',
                        textAlign: 'center',
                        fontWeight: 500,
                    }}
                >
                    {currentZoneName || props.currentPage + 1}
                </Typography>
                <IconButton
                    sx={{ pointerEvents: 'auto' }}
                    disabled={!hasNext}
                    onClick={() => props.setPage(props.currentPage + 1)}
                    size="small"
                >
                    <ChevronRightIcon />
                </IconButton>
            </Paper>
        </Box>
    );
}
